import React from 'react'
import ReactDom from 'react-dom'


import App from './App';

ReactDom.render(<App />, document.getElementById('root')); 

// This Command is used to render the Element in index.html which Contains the root element
